import { ButtonProps } from '@mui/material';

const colors = {
  accentColor: '#e37c99',
  accentColor04: 'rgba(227,124,153,0.04)',
  accentColor10: 'rgba(227,124,153,0.1)',
  accentColor20: 'rgba(227,124,153,0.2)',
  accentColorDark: '#df6789',
  accentColorLight: '#df809a',
  alpha50: 'rgba(17, 17, 17, 0.5)',
  bg: '#F7F7F8',
  bgDark: 'rgba(227,227,227,0.75)',
  black: '#111111',
  blue: '#006FBA',
  blueDark: '#005A97',
  blueLight: 'rgb(217,238,244)',
  divider: '#AFB1B6',
  emails: {
    email: 'rgb(240,243,248)',
    emailHover: 'rgba(217,226,236,0.3)',
    emailSelected: 'rgb(224,231,242)',
    thread: '#FFFFFF',
    threadHover: 'rgba(234,234,234,0.2)',
    threadSelected: 'rgb(240,243,248)',
  },
  green: '#0D7B60',
  greenDark: '#025740',
  greenLight: '#DDFFF7',
  grey: '#AFB1B6',
  greyDark: '#595959',
  greyDarker: '#373737',
  greyLight: '#D8D8DA',
  navy: '#2C3E90',
  navyDark: '#25357A',
  orange: '#d86d50',
  orangeDark: '#d15432',
  purple: '#801EFF',
  purpleLight: '#aa6afd',
  red: '#BD2832',
  redDark: '#a20c16',
  stroke: '#EAEAEA',
  stroke20: 'rgba(234,234,234,0.2)',
  stroke40: 'rgba(234,234,234,0.4)',
  stroke60: 'rgba(234,234,234,0.6)',
  turquoise: '#15BEF0',
  turquoiseDark: '#05a1d0',
  white: '#FFFFFF',
  yellow: '#F7B500',
} as const;

export const themeColors: typeof colors & Record<Required<ButtonProps>['color'], string> = {
  ...colors,
  error: colors.red,
  info: colors.grey,
  inherit: colors.accentColor,
  neutral: colors.navy,
  primary: colors.accentColor,
  secondary: colors.blue,
  success: colors.green,
  warning: colors.orange,
};
